import { DateColumnHeader } from "src/components/timeZone/dateColumnHeader";
import { DateType } from "src/dataTypes";

import { agGridResourcesDateTimeDefault, Config } from "./baseColumnConfig";
import { GenericTypeColumn } from "./genericTypeColumn";

export class DateColumn extends GenericTypeColumn<DateType> {
  constructor(config: Config) {
    const { label = "Date", size = 250, ...rest } = config;
    const enhancedConfig: Config = {
      label,
      size,
      header: config.header || (() => <DateColumnHeader label={label} />),
      ...rest
    };
    super({ ...enhancedConfig }, agGridResourcesDateTimeDefault);
  }

  identity(value?: DateType) {
    const dateLike = value?.valueOf();
    // if dateType is defined, yield a serialized time in milliseconds
    return dateLike instanceof Date ? dateLike.getTime().toString() : undefined;
  }

  // internal comparison for change detection in grid
  equals(old: DateType, next: DateType): boolean {
    // unwrap the Date object to a timestamp for comparison
    return old.valueOf().valueOf() === next.valueOf().valueOf();
  }
}
